import React from 'react';
import * as PropTypes from 'prop-types';
import './style.scss';

const replaceEmailAddress = (text) => {
  return text.replace(/([A-Za-z]+@[A-Za-z]+\.[A-Za-z]+)/g, '<a href="mailto:$1">$1</a>');
};

const Disclaimer = ({ text }) => {
  if (!text) return null;
  return (
    <article className="disclaimer">
      {/* eslint-disable-next-line react/no-danger */}
      <p dangerouslySetInnerHTML={{ __html: replaceEmailAddress(text) }} />
    </article>
  );
};

Disclaimer.propTypes = {
  text: PropTypes.string.isRequired
};

export default Disclaimer;
